import {
  getDateFromIsoString,
  getSearchTextFromDate,
  isIsoDateTimeString,
} from "../dateFormatUtils/dateFormatUtils";

export const getSearchTextFromValue = (value: unknown): string => {
  if (value === null || value === undefined) {
    return "";
  }

  if (typeof value === "string") {
    if (!isIsoDateTimeString(value)) {
      return value;
    }

    const dateValue = getDateFromIsoString(value);

    if (dateValue) {
      return getSearchTextFromDate(dateValue);
    }

    return value;
  }

  if (typeof value === "number" || typeof value === "boolean" || typeof value === "bigint") {
    return String(value);
  }

  if (value instanceof Date) {
    return getSearchTextFromDate(value);
  }

  if (Array.isArray(value)) {
    return value.map((item) => getSearchTextFromValue(item)).join(" ");
  }

  if (typeof value === "object") {
    return Object.values(value)
      .map((item) => getSearchTextFromValue(item))
      .join(" ");
  }

  return String(value);
};
